import session from '../util/session'

up.compiler('[data-current-subject-area]', (_element: HTMLElement, { key }: { key: string }) => {
  if (key) {
    session.subjectAreaCurrentKey = key
  }
})
